import { render } from "./ChooseFood.vue?vue&type=template&id=34e7cd4b"
import script from "./ChooseFood.vue?vue&type=script&lang=js"
export * from "./ChooseFood.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__